import { connect } from 'react-redux'
import UserAvatarWithStats from './UserAvatarWithStats'
import NumbersAnimationProvider from 'app/components/AnimationProviders/NumbersAnimationProvider'
import {
  getIdentityInitials,
  getIdentityAvatar,
  getIdentityProgressCurrentStreakCurrent,
  getProgressCirclePercentages,
} from 'store/entities/identity/selectors'

const mapStateToProps = state => ({
  initials: getIdentityInitials(state),
  avatar: getIdentityAvatar(state),
  streakCurrent: getIdentityProgressCurrentStreakCurrent(state),
  isUserBlock: true,
  circleProps: {
    cx: 50,
    cy: 50,
    r: 48,
    strokeWidth: 4,
  },
  animate: {
    proTrackProgress: {
      from: 0,
      to: getProgressCirclePercentages(state),
      easing: 'in-sine',
      duration: 1200,
    },
  },
})

// TODO: move to domains/common
export default connect(mapStateToProps)(NumbersAnimationProvider(UserAvatarWithStats))
